import { Icon } from '@iconify/react/dist/iconify.js';
import React, { Select } from 'react';
import { Link } from 'react-router-dom';
import TablaComprobantes from '../utils/TablaComprobantes';

const ComprobantesAdminLayer = () => {
    return (
        <>
            <TablaComprobantes />
        </>
    );
};

export default ComprobantesAdminLayer;